import { Project, ProjectType } from '../types';
import axios from 'axios';

/**
 * Gets a list of projects from CONNECTED context service
 *
 * @param {GetProjectsRequest} _ {@link GetProjectsRequest} object
 * @returns {Promise} List of project WSG instances
 */
export const fetchProjects = async (
  type: ProjectType,
  searchPhrase?: string
): Promise<Project[]> => {
  const paramString = buildParams(
    type === 'mrus',
    type === 'favorites',
    searchPhrase
  );
  return (await axios.get<Project[]>(`api/projects?${paramString}`)).data;
};

/**
 * Gets project information for a given project ID
 * from CONNECTED context service
 *
 * @param {string} projectId Project ID to get details for
 * @returns {Promise} Project WSG instance
 */
export const fetchProjectDetails = async (
  projectId: string
): Promise<Project> => {
  return (await axios.get<Project>(`api/project/${projectId}`)).data;
};

const buildParams = (
  isMru: boolean = false,
  isFavorite: boolean = false,
  searchPhrase: string | undefined = undefined
): string => {
  const params: string[] = [];
  if (!isFavorite && !isMru && !searchPhrase) {
    params.push('rbacOnly=true');
  } else {
    if (isFavorite) params.push('isFavorite=true');
    if (isMru) params.push('isMRU=true');
    if (searchPhrase)
      params.push(
        `filter=name+like+'${searchPhrase}'+or+number+like+'${searchPhrase}'`
      );
  }

  return params.filter(p => p !== '').join('&');
};
